import React from 'react';
import { useSelector } from 'react-redux';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';
import { formatCurrency } from 'utils/currency';

import { PayWallFullState } from 'components/PayWall/Redux/Reducer.type';
import { getTotalDueToday } from 'components/PayWall/Redux/Selectors';

function NextBillingCycle() {
  const recurringAmount = useSelector((state: PayWallFullState) => state.payWall.planSummaryPreview.recurring_amount);
  const renewalDate = useSelector((state: PayWallFullState) => state.payWall.planSummaryPreview.renewal_date);
  const recurringSalesTax = useSelector(
    (state: PayWallFullState) => state.payWall.planSummaryPreview.recurring_sales_tax
  );

  const recurringAmountString = formatCurrency(parseFloat(recurringAmount) + parseFloat(recurringSalesTax));

  return (
    <Box display="flex" flexWrap="noWrap" justifyContent="space-between">
      <Box display="flex" flexGrow="1">
        <Typography variant="subtitle1">Amount due on renewal date ({renewalDate})</Typography>
      </Box>
      <Box>
        <Typography variant="subtitle1" align="right" data-testid="amount-due-renewal-downgrade">
          {recurringAmountString}
        </Typography>
      </Box>
    </Box>
  );
}

function TotalNotice() {
  const total = useSelector(getTotalDueToday);

  if (Number(total) === 0) {
    return null;
  }

  return (
    <Box>
      <Typography variant="body2" data-testid="renewal-notice">
        Changes take place on your renewal date.
      </Typography>
    </Box>
  );
}

export default function DowngradeTotal(): JSX.Element {
  return (
    <>
      <NextBillingCycle />
      <TotalNotice />
    </>
  );
}
